<h4 class="h4 chart-title chart-title--thin margin-top-none">
  {{ 'dashboard.' + key | translate }}
  <gl-tooltip posBottom [text]="tooltipText"></gl-tooltip>
</h4>
<div class="chart center" *ngIf="ratio" [ngClass]="'chart' + ratio">
  <div class="chart-slice">
    <div class="chart-bar"></div>
    <div class="chart-fill"></div>
  </div>
  <span class="chart-value">{{ ratio }}%</span>
</div>
<div class="col s12 chart-notice" *ngIf="!ratio">
  {{ 'dashboard.emptyRatios' | translate }}
</div>
